import QueryString from "qs";
import mainAxios from "../api/mainAxios";
import toast from "react-hot-toast";

export const setActiveView = (view) => ({
  type: "SET_ACTIVE_VIEW",
  payload: view,
});

export const setActiveOnglet = (onglet) => ({
  type: "SET_ACTIVE_ONGLET",
  payload: onglet,
});

export const fetchProgrammes = (query = {}, ongletType, ongletId) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_PROGRAMMES_REQUEST" });

    const qs = QueryString.stringify(query, { encode: false });

    let url = `api/paginate-sort-programmes?${qs}`;

    try {
      const response = await mainAxios.get(url);

      dispatch({
        type: "FETCH_PROGRAMMES_SUCCESS",
        payload: {
          ...response.data.data,
          ongletType,
          ongletId,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_PROGRAMMES_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const hideShowProgramme = (programmeId, hidden) => {
  return async (dispatch) => {
    try {
      await mainAxios.put(
        `${process.env.REACT_APP_ENDPOINT_URL}api/programmes/${programmeId}`,
        {
          data: { hidden: hidden },
        },
      );
    } catch (error) {
      console.error(error);
      toast.error(
        "Erreur lors de la mise à jour de la visibilité du programme",
      );
    }
  };
};

export const fetchSingleProgram = (programmeId, showOnglet = true) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "FETCH_SINGLE_PROGRAM_REQUEST" });

      const cashedPrograms = getState().immobilierReducer.cashedSinglePrograms;
      const cashedProgram = cashedPrograms.find(
        (program) => program.documentId === programmeId,
      );
      if (cashedProgram) {
        dispatch({ type: "REPLACE_SINGLE_PROGRAM", payload: cashedProgram });

        showOnglet &&
          dispatch({
            type: "ADD_NEW_ONGLET",
            payload: {
              results: cashedProgram,
              type: "programme",
              id: `${cashedProgram.id}`,
              name: cashedProgram.name,
            },
          });
      } else {
        const query = QueryString.stringify({
          populate: {
            city: {
              fields: ["name", "code", "code_departement"],
            },
            api_parent: {
              fields: ["name"],
            },
            images: {
              populate: { image: { fields: ["url"] } },
            },
            lots: {
              populate: {
                geo_orientations: true,
                disponibility: { fields: ["disponibilite"] },
                images: {
                  populate: { image: { fields: ["url"] } },
                },
                programme_parent: { fields: ["*"] },
                documents_pdfs: {
                  populate: { document: { fields: ["url"] } },
                },
                project_types: true,
              },
            },
            promoteur: {
              populate: {
                promoteur_accesses: {
                  fields: ["documentId", "login", "password"],
                  populate: {
                    secteur: {
                      fields: ["name", "id", "documentId"],
                      populate: {
                        users: {
                          fields: ["*"],
                          populate: {
                            profile_image: { fields: ["url"] },
                          },
                        },
                      },
                    },
                  },
                },
                logo: { fields: ["url"] },
              },
            },
            documents_pdfs: {
              populate: { document: { fields: ["url"] } },
            },
          },
        });
        const response = await mainAxios.get(
          `api/programmes/${programmeId}?${query}`,
        );
        dispatch({
          type: "FETCH_SINGLE_PROGRAM_SUCCESS",
          payload: response.data.data,
        });

        showOnglet &&
          dispatch({
            type: "ADD_NEW_ONGLET",
            payload: {
              results: response.data.data,
              type: "programme",
              id: `${response.data.data.id}`,
              name: response.data.data.name,
            },
          });
      }
    } catch (error) {
      dispatch({
        type: "FETCH_SINGLE_PROGRAM_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchLots = (query = {}, ongletType, ongletId) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_LOTS_REQUEST" });

    try {
      const qs = QueryString.stringify(query, { encode: false });

      let url = `api/paginate-sort-lots?${qs}`;

      const response = await mainAxios.get(url);

      dispatch({
        type: "FETCH_LOTS_SUCCESS",
        payload: {
          ...response.data.data,
          ongletType,
          ongletId,
        },
      });
    } catch (error) {
      dispatch({
        type: "FETCH_LOTS_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const fetchSingleLot = (documentId) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCH_SINGLE_LOT_REQUEST",
      payload: documentId,
    });

    const query = QueryString.stringify({
      populate: {
        images: {
          populate: { image: { fields: ["url"] } },
        },
        api_parent: {
          fields: ["name"],
        },
        programme_parent: {
          populate: {
            lots: {
              populate: {
                disponibility: { fields: ["disponibilite"] },
                project_types: { fields: ["label", "projectType"] },
                images: {
                  populate: { image: { fields: ["url"] } },
                },
              },
            },
            promoteur: {
              populate: {
                logo: { fields: ["url"] },
              },
            },
          },
        },
        documents_pdfs: {
          populate: { document: { fields: ["url"] } },
        },
        project_types: {
          fields: ["label", "projectType"],
        },
        geo_orientations: { fields: ["orientation", "documentId"] },
      },
    });

    try {
      const response = await mainAxios.get(`api/lots/${documentId}?${query}`);

      const lotData = {
        ...response.data.data,
        id: documentId,
      };

      dispatch({
        type: "FETCH_SINGLE_LOT_SUCCESS",
        payload: lotData,
      });

      dispatch({
        type: "ADD_NEW_ONGLET",
        payload: {
          results: response.data.data,
          type: "lot",
          id: `lot-${response.data.data.id}`,
          name: response.data.data.reference,
        },
      });

      return lotData;
    } catch (error) {
      dispatch({
        type: "FETCH_SINGLE_LOT_FAILURE",
        payload: error.message,
        meta: { documentId },
      });
      throw error;
    }
  };
};

export const deepSearchFunction = (
  formData,
  type,
  id,
  name,
  updateCard = false,
) => {
  return async (dispatch) => {
    dispatch({ type: "DEEP_SEARCH_LOADING", payload: `${type}-${id}` });

    try {
      // Transform formData into query parameters
      const queryParams = {};
      // General section
      if (formData.nomRecherche)
        queryParams.nomRecherche = formData.nomRecherche;
      if (formData.usage) queryParams.usage = formData.usage;
      if (formData.lieu && formData.lieu.length > 0)
        queryParams.lieu = formData.lieu;
      if (formData.perimetere) queryParams.perimetere = formData.perimetere;
      if (formData.dispositif && formData.dispositif.length > 0)
        queryParams.dispositif = formData.dispositif;
      if (formData.zone_fiscale && formData.zone_fiscale.length > 0)
        queryParams.zone_fiscale = formData.zone_fiscale;
      if (formData.statutLot) queryParams.statutLot = formData.statutLot;
      if (formData.flux && formData.flux.length > 0)
        queryParams.flux = formData.flux;
      if (formData.origine) queryParams.origine = formData.origine;
      if (formData.nature_du_mandat)
        queryParams.nature_du_mandat = formData.nature_du_mandat;

      // Economic section
      if (formData.budgetMin) queryParams.budgetMin = formData.budgetMin;
      if (formData.budgetMax) queryParams.budgetMax = formData.budgetMax;
      if (formData.prixM2Min) queryParams.prixM2Min = formData.prixM2Min;
      if (formData.prixM2Max) queryParams.prixM2Max = formData.prixM2Max;
      if (formData.rentabiliteMin)
        queryParams.rentabiliteMin = formData.rentabiliteMin;
      if (formData.honorairesMin)
        queryParams.honorairesMin = formData.honorairesMin;

      // Lot section
      if (formData.referenceLot && formData.referenceLot.length > 0)
        queryParams.referenceLot = formData.referenceLot;
      if (formData.type && formData.type.length > 0)
        queryParams.type = formData.type;
      if (formData.surfaceMin) queryParams.surfaceMin = formData.surfaceMin;
      if (formData.surfaceMax) queryParams.surfaceMax = formData.surfaceMax;
      if (formData.espaceTotalMin)
        queryParams.espaceTotalMin = formData.espaceTotalMin;
      if (formData.espaceTotalMax)
        queryParams.espaceTotalMax = formData.espaceTotalMax;
      if (formData.typologieLot && formData.typologieLot.length > 0)
        queryParams.typologieLot = formData.typologieLot;
      if (formData.etage && formData.etage.length > 0)
        queryParams.etage = formData.etage;
      if (formData.annexe && formData.annexe.length > 0)
        queryParams.annexe = formData.annexe;

      // Programme section
      if (formData.programme) queryParams.programme = formData.programme;
      if (formData.promoteur) queryParams.promoteur = formData.promoteur;
      if (formData.tag) queryParams.tag = formData.tag;
      if (formData.label) queryParams.label = formData.label;
      if (formData.nouveaute_depuis)
        queryParams.nouveaute_depuis = formData.nouveaute_depuis;
      if (formData.lot_maximum) queryParams.lot_maximum = formData.lot_maximum;
      if (formData.mes_activites)
        queryParams.mes_activites = formData.mes_activites;
      if (formData.allotement) queryParams.allotement = formData.allotement;
      if (formData.offre_speciale)
        queryParams.offre_speciale = formData.offre_speciale;
      if (formData.programmeHidden)
        queryParams.programmeHidden = formData.programmeHidden;
      if (formData.missingLotData)
        queryParams.missingLotData = formData.missingLotData;
      if (formData.minLat) queryParams.minLat = formData.minLat;
      if (formData.maxLat) queryParams.maxLat = formData.maxLat;
      if (formData.minLng) queryParams.minLng = formData.minLng;
      if (formData.maxLng) queryParams.maxLng = formData.maxLng;

      const query = QueryString.stringify(queryParams);

      // Make the API call to the custom endpoint
      const response = await mainAxios.get(
        `/api/deep-search-properties?${query}`,
      );
      dispatch({
        type: "ADD_NEW_ONGLET",
        payload: {
          results: response.data.data,
          type,
          id,
          name,
          query: queryParams,
          updateCard,
        },
      });

      if (response.data.data.length === 0) {
        toast.error("Aucun résultat trouvé");
        dispatch({
          type: "DEEP_SEARCH_FAILURE",
          payload: "Aucun résultat trouvé",
        });
      } else {
        dispatch({ type: "DEEP_SEARCH_SUCCESS", payload: `${type}-${id}` });
      }
      return response.data.data;
    } catch (error) {
      console.error("Advanced search error:", error);
      dispatch({
        type: "DEEP_SEARCH_FAILURE",
        payload: error.message || "Failed to execute search",
      });
    }
  };
};

export const getSearchResultsCount = (formData) => {
  return async (dispatch) => {
    try {
      // Transform formData into query parameters
      const queryParams = {};

      // General section
      if (formData.nomRecherche)
        queryParams.nomRecherche = formData.nomRecherche;
      if (formData.usage) queryParams.usage = formData.usage;
      if (formData.lieu) queryParams.lieu = formData.lieu;
      if (formData.perimetere) queryParams.perimetere = formData.perimetere;
      if (formData.dispositif && formData.dispositif.length > 0)
        queryParams.dispositif = formData.dispositif;
      if (formData.zone_fiscale && formData.zone_fiscale.length > 0)
        queryParams.zone_fiscale = formData.zone_fiscale;
      if (formData.statutLot) queryParams.statutLot = formData.statutLot;
      if (formData.flux && formData.flux.length > 0)
        queryParams.flux = formData.flux;
      if (formData.origine) queryParams.origine = formData.origine;
      if (formData.nouveaute_depuis)
        queryParams.nouveaute_depuis = formData.nouveaute_depuis;

      // Economic section
      if (formData.budgetMin) queryParams.budgetMin = formData.budgetMin;
      if (formData.budgetMax) queryParams.budgetMax = formData.budgetMax;
      if (formData.prixM2Min) queryParams.prixM2Min = formData.prixM2Min;
      if (formData.prixM2Max) queryParams.prixM2Max = formData.prixM2Max;
      if (formData.rentabiliteMin)
        queryParams.rentabiliteMin = formData.rentabiliteMin;
      if (formData.honorairesMin)
        queryParams.honorairesMin = formData.honorairesMin;

      // Lot section
      if (formData.referenceLot && formData.referenceLot.length > 0)
        queryParams.referenceLot = formData.referenceLot;
      if (formData.type && formData.type.length > 0)
        queryParams.type = formData.type;
      if (formData.surfaceMin) queryParams.surfaceMin = formData.surfaceMin;
      if (formData.surfaceMax) queryParams.surfaceMax = formData.surfaceMax;
      if (formData.espaceTotalMin)
        queryParams.espaceTotalMin = formData.espaceTotalMin;
      if (formData.espaceTotalMax)
        queryParams.espaceTotalMax = formData.espaceTotalMax;
      if (formData.typologieLot && formData.typologieLot.length > 0)
        queryParams.typologieLot = formData.typologieLot;
      if (formData.etage && formData.etage.length > 0)
        queryParams.etage = formData.etage;
      if (formData.annexe && formData.annexe.length > 0)
        queryParams.annexe = formData.annexe;

      // Programme section
      if (formData.programme && formData.programme.length > 0)
        queryParams.programme = formData.programme;
      if (formData.promoteur && formData.promoteur.length > 0)
        queryParams.promoteur = formData.promoteur;
      if (formData.label && formData.label.length > 0)
        queryParams.label = formData.label;
      if (formData.mes_activites)
        queryParams.mes_activites = formData.mes_activites;
      if (formData.allotement) queryParams.allotement = formData.allotement;
      if (formData.offre_speciale)
        queryParams.offre_speciale = formData.offre_speciale;
      if (formData.programmeHidden)
        queryParams.programmeHidden = formData.programmeHidden;
      if (formData.missingLotData)
        queryParams.missingLotData = formData.missingLotData;

      const query = QueryString.stringify(queryParams);

      // Make the API call to get count only
      const response = await mainAxios.get(`/api/deep-search-count?${query}`);

      return {
        lotsCount: response.data.lotsCount || 0,
        programmesCount: response.data.programmesCount || 0,
      };
    } catch (error) {
      console.error("Search count error:", error);
      return { lotsCount: 0, programmesCount: 0 };
    }
  };
};

export const getMissingLots = () => {
  return async (dispatch) => {
    try {
      // Transform formData into query parameters
      const queryParams = { missingLotData: true };

      const query = QueryString.stringify(queryParams);

      // Make the API call to get count only
      const response = await mainAxios.get(`/api/deep-search-count?${query}`);

      return {
        lotsCount: response.data.lotsCount || 0,
        programmesCount: response.data.programmesCount || 0,
      };
    } catch (error) {
      console.error("Search count error:", error);
      return { lotsCount: 0, programmesCount: 0 };
    }
  };
};

export const closeSearch = () => {
  return {
    type: "CLOSE_SEARCH",
  };
};

export const closeOnglet = (id) => {
  return {
    type: "CLOSE_ONGLET",
    payload: id,
  };
};
